// Shared design-system a11y: keyboard focus ring + spinner keyframes.
// Runs once per document (module scope), used by every interactive component.
export function installDSFocus() {
  if (typeof document === 'undefined') return;
  if (document.getElementById('ds-a11y-style')) return;
  const s = document.createElement('style');
  s.id = 'ds-a11y-style';
  s.textContent =
    '[data-ds-focusable]:focus-visible{outline:2px solid var(--focus-ring);outline-offset:2px}' +
    '[data-ds-focusable]{outline:none}' +
    '@keyframes ds-spin{to{transform:rotate(360deg)}}';
  document.head.appendChild(s);
}
installDSFocus();
